<template>
  <div class="info-box">
    <el-row class="title">{{$t('personalInformation.info.title')}}</el-row>
    <xl-form class="form_class_box" inline-message :model="form" :inline="true" :rules="rules" ref="formRef" label-position="top">
      <el-row :gutter="24" class="contentBox">
        <el-col :span="12">
          <xl-form-item :label="$t('personalInformation.info.name')" prop="nickName">
            <xl-input v-model="form.nickName" :placeholder="$t('personalInformation.info.placeholderNickName')" />
          </xl-form-item>
        </el-col>
        <el-col :span="12">
          <xl-form-item :label="$t('personalInformation.info.loginName')">
            <xl-input disabled :value="form.phone || form.email" />
          </xl-form-item>
        </el-col>
        <el-col :span="12">
          <xl-form-item :label="$t('personalInformation.info.country')" prop="country">
            <xl-select filterable :placeholder="$t('personalInformation.info.placeholderCountry')"
						:options="$store.state.countryList" v-model="form.country" disabled
            ></xl-select>
          </xl-form-item>
        </el-col>
        <el-col :span="12">
          <xl-form-item :label="$t('personalInformation.info.registerTime')">
            <xl-input disabled v-model="form.createOn" />
          </xl-form-item>
        </el-col>
        <el-col :span="24">
          <xl-form-item :label="$t('personalInformation.info.lastTimeLogin')">
            <xl-input disabled v-model="form.lastOn" />
          </xl-form-item>
        </el-col>
        <el-col :span="24">
          <xl-form-item :label="$t('personalInformation.info.lastPlaceLogin')">
            <xl-input disabled v-model="form.region" />
          </xl-form-item>
          <span class="notes">{{$t('personalInformation.info.placeNote')}}</span>
        </el-col>
        <el-col :span="24" class="marketMail" v-if="isMarketMailCheck">
					<!-- marketMail -->
					<el-checkbox @change="marketMailOperation" v-model="isMarketMail" :true-label="Subscribe" :false-label="Unsubscribe"><span class="agreement">{{$t('personalInformation.info.marketMail.text')}}</span></el-checkbox>
        </el-col>
        <el-col :span="24">
          <xl-form-item label>
            <div class="yinsi">
              <i class="iconfont icon-zhuyi"></i>
              <span class="agreement">
                {{$t('personalInformation.info.privacyPolicyNoteBefore')}}
								<span @click="$store.commit( 'setPrivacyPolicySwitchInfo' )" style="text-decoration: underline;margin: 0 4px;">{{$t('personalInformation.info.privacyPolicyNote')}}</span>
								<span @click="$store.commit( 'setTermsOfUseSwitchInfo' )" style="text-decoration: underline;margin: 0 4px 0 0;">{{' '+ $t('app-login.termsOfUse')}}</span>
								{{$t('personalInformation.info.privacyPolicyNoteAfter')}}
              </span>
            </div>
          </xl-form-item>
        </el-col>
      </el-row>
      <xl-form-item>
        <xl-button type="primary" @click="onSubmit(formRef)" :disabled="isSubmit" :loading="submitLoading">
					{{$t('common.preservation')}}
				</xl-button>
      </xl-form-item>
    </xl-form>
  </div>
</template>

<script setup>
import { XlButton, XlMessage, XlSelect, XlInput, XlForm, XlFormItem, XlMessageBox } from '@shining3d/ui-components';
import { ElRow, ElCol, ElCheckbox } from "@shining3d/xl-element-plus";
import { ref, computed, toRefs } from 'vue';
import { useLang } from '@shining3d/common-module/lang.js';
import info from '../api';
import _isEqual from 'lodash/isEqual';
import _get from 'lodash/get';
import { $getInfo } from '../index.js';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
const route = useRoute();
// 是否展示邮件营销
const isMarketMailCheck = route?.meta?.isMarketMailCheck || false;
// 获取语言
const { $t } = useLang( '@shining3d/info-component.infoComponent' );
const $store = useStore();
// 设置常量
const Subscribe = 'subscribe';
const Unsubscribe = 'unsubscribe';

const submitLoading = ref( false );
const formRef = ref();
const isMarketMail = ref(Subscribe);

const rules = ref({
	nickName: [
		{ required: true, message: $t( 'rules.notEmpty' ), trigger: 'blur' },
		{ min: 1, max: 128, message: $t( 'rules.lengthLimit', { min: 1, max: 128 }), trigger: 'blur' },
	],
	country: [
		{ required: true, message: $t( 'rules.notEmpty' ), trigger: 'blur' }
	]
});

// 获取个人信息
const form = ref({});
const getInfo = async () => {
	await $getInfo().then(( res ) => { form.value = res; });
};
const getMarketMailStatus = ()=>{
	info.marketMailStatus().then((res)=>{
		if ( res.status === 'success' ) {
			isMarketMail.value = _get(res.result,'isMarketMailSubscribed', true) ? Subscribe : Unsubscribe;
		}
	})
}
getInfo();
isMarketMailCheck && getMarketMailStatus();

// 邮件营销
const marketMailOperation = async ( val ) => {
	if(isMarketMail.value === Subscribe){
		const res = await info.marketMail({ action: val, userSource: window.app.entryApiName || '' });
		if ( res.status === 'success' ) {
			XlMessage({ type: 'success', message: $t( 'messages.successEdit' ) });
			getMarketMailStatus();
		}
	}else{
		XlMessageBox({
			title: $t( 'personalInformation.info.marketMail.msg.title' ),
			message: $t( `personalInformation.info.marketMail.msg.${val}`),
			confirmButtonText: $t( 'common.determine' ),
			cancelButtonText: $t( 'common.cancel' ),
			type: isMarketMail.value === Subscribe ? 'info' : 'error',
			beforeClose: async ( action, instance, done ) => {
				if ( action === 'confirm' ) {
					instance.confirmButtonLoading = true;
					const res = await info.marketMail({ action: val, userSource: window.app.entryApiName || '' });
					if ( res.status === 'success' ) {
						done();
					}
					instance.confirmButtonLoading = false;
				} else {
					isMarketMail.value = isMarketMail.value === Unsubscribe ? Subscribe : Unsubscribe
					done();
				}
			}
		}).then(() => {
			getMarketMailStatus();
			XlMessage({ type: 'success', message: $t( 'messages.successEdit' ) });
		})
	}
};
// 判断信息是否修改
const isSubmit = computed(() => _isEqual( toRefs( form.value.nickName ), toRefs( $store.state.userInfo.nickName )) && _isEqual( toRefs( form.value.country ), toRefs( $store.state.userInfo.country )));

// 保存个人信息
const onSubmit = async ( formEl ) => {
	if ( !formEl ) { return; }
	await formEl.validate( async ( valid, fields ) => {
		if ( valid ) {
			const formData = {
				userID: form.value.userID,
				nickName: form.value.nickName,
				enablePromotion: form.value.enablePromotion,
				country: form.value.country,
				defaultDentalOrderReceive: form.value.defaultDentalOrderReceive
			}; 
			submitLoading.value = true;
			const res = await info.setInfo( formData );
			if ( res.status === 'success' ) {
				XlMessage({
					message: $t( 'messages.successEdit' ),
					type: 'success'
				});
				getInfo();
			}
			submitLoading.value = false;
		} 
	});
};
</script>

<style lang="scss" scoped>
.info-box {
	width: 100%;
	.el-form {
		max-width: 780px;
		padding-top: 30px;
		display: block;
		.xl-button {
			padding: 10px 30px;
			@include h6();
		}
		.xl-select,.xl-input{
			height: 44px;
			width: 100%;
		}
		& > .el-row {
			& > .el-col {
				margin-bottom: 24px;
				:deep(.el-form-item) {
					margin-right: 0;
					margin-bottom: 0;
					.el-form-item__label {
						color: var(--oem-color-n10);
					}
				}
				.notes {
					@include h6();
					color: var(--oem-color-n7);
				}
				.agreement {
					@include h6();
					color: var(--oem-color-n9);
					span {
						cursor: pointer;
						color: var(--oem-color-b4);
					}
				}
				:deep(.agreementCheckBox) {
					color: var(--oem-color-n7);
					@include h6();
					span {
						@include h6();
					}
				}
			}
			.marketMail{
				margin-bottom: 0;
			}
		}
	}
	.yinsi{
		display: flex;
		i{
			font-size: $icon-small;
			line-height: 20px;
			margin-right: 2px;
		}
	}
	.title {
		@include h2();
		color: var(--oem-color-n10);
		font-family: $font-family45;
	}
	.icon-zhuyi {
		color: var(--oem-color-n6);
	}
}
</style>
